// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 441 ? "secondary" : chunkId) + "." + {"441":"c67aa2a2e387d3a171a9","798":"a4b81c30b2ddb549defa"}[chunkId] + ".css";
};